
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/originals/[id]",
      function () {
        return require("private-next-pages/originals/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/originals/[id]"])
      });
    }
  